module.exports = __webpack_public_path__ + "img/image15.c9a6c303.png";